import { Box, Chip, type ChipProps, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

const INSIDE_COUNT_SX: SxProps<Theme> = {
    color: 'action.disabled',
    ml: 0.5,
};

const AFTER_SX: SxProps<Theme> = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0.5,
};

type ModalityChipProps = {
    modality: string;
    count?: number;
    /** 'inside' shows ×N in the chip; 'after' shows it as a mono span after. Only when N > 1. */
    countPlacement?: 'inside' | 'after';
    size?: ChipProps['size'];
    /** `primary` marks a chosen one; `warning` one that cannot be shown as it is. */
    color?: ChipProps['color'];
};

/** Inline modality tag chip with an optional ×N multiplier. */
export default function ModalityChip({
    modality,
    count = 1,
    countPlacement = 'inside',
    size,
    color,
}: ModalityChipProps) {
    const chip = (
        <Chip
            variant="tag"
            size={size}
            color={color}
            label={
                <>
                    {modality}
                    {countPlacement === 'inside' && count > 1 && (
                        <Box component="span" sx={INSIDE_COUNT_SX}>
                            ×{count}
                        </Box>
                    )}
                </>
            }
        />
    );
    if (countPlacement === 'inside' || count <= 1) {
        return chip;
    }
    return (
        <Box component="span" sx={AFTER_SX}>
            {chip}
            <Typography variant="monoMeta">×{count}</Typography>
        </Box>
    );
}
